module.exports = __webpack_public_path__ + "static/media/test5_1.0a35f767.png";